import React, { useState } from "react";
import { FaEnvelope, FaFacebookF, FaInstagram, FaLinkedinIn, FaPhoneAlt, FaYoutube } from "react-icons/fa";
import { FaGlobe, FaLocationCrosshairs } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { assets } from "../../Assets/assets";
import services from "../../config/services.json"
import itServices from "../../config/itServices.json"

const MainFooter = () => {

  const socialIcons = [
    { icon: <FaFacebookF />, link: "#" },
    { icon: <FaInstagram />, link: "#" },
    { icon: <FaLinkedinIn />, link: "#" },
    { icon: <FaYoutube />, link: "#" },
  ];

  const footerQuickLinks = [
    { label: "About Us", path: "/aboutus" },
    // { label: "Services", path: "/services" },
    // { label: "IT Solutions", path: "/solutions" },
    { label: "Career", path: "/career" },
    { label: "Blog", path: "/blog" },
    { label: "Contact Us", path: "/contactus" },
  ];

  return (
    <footer className="bg-[#ECF4FF] w-full border-t">
      <div className="max-w-[1400px] pt-14 pb-6 px-6 mx-auto space-y-10">

        <div className="grid grid-cols-1 items-start sm:grid-cols-2 lg:grid-cols-5 gap-8">

          <div className="space-y-4 max-w-[220px]">
            <img src={assets.navlogo} alt="Logo" className="w-[100px]" />

            <p className=" text-secondaryTextColor leading-5">
              We understand that attracting, qualifying, placing, and retaining
              the best candidates for our clients requires exceptional talent.
            </p>

            <div className="flex gap-4 text-primaryNavyTextColor text-[18px]">
              {socialIcons.map((item, index) => (
                <Link
                  key={index}
                  to={item.link}
                  className="hover:text-primaryColor transition duration-300"
                >
                  {item.icon}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-semibold  tracking-wide text-primaryNavyTextColor mb-4">
              QUICK LINKS
            </h3>
            <ul className="space-y-2 text-secondaryTextColor w-fit">
              {footerQuickLinks.map((item, index) => (
                <Link key={index} to={item.path} className="block">
                  <li className="hover:text-primaryColor transition ">{item.label}</li>
                </Link>
              ))}
            </ul>

          </div>

          <div>
            <h3 className="font-semibold  tracking-wide text-primaryNavyTextColor mb-4">
              IT SOLUTIONS
            </h3>
            <ul className="space-y-2  text-secondaryTextColor w-fit">
              {itServices.map((service, index) => (
                <Link key={index} to={`/itsolutions/${service.id}`} className="block">
                  <li className="hover:text-primaryColor transition ">{service.servieName}</li>
                </Link>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-semibold  tracking-wide text-primaryNavyTextColor mb-4">
              SERVICES
            </h3>
            <ul className="space-y-2  text-secondaryTextColor w-fit">
              {services.map((service, index) => (
                <Link key={index} to={`/service/${service.id}`} className="block">
                  <li className="hover:text-primaryColor transition ">{service.title}</li>
                </Link>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-semibold  tracking-wide text-primaryNavyTextColor mb-4">
              CONTACT
            </h3>
            <div className="space-y-3 text-secondaryTextColor">
              <a href="tel:+919078470877" className="flex gap-2 items-center">
                <FaPhoneAlt className="text-primaryColor" />+91 9078470877
              </a>
              <p className="flex gap-2 items-center">
                <span><FaLocationCrosshairs className="text-primaryColor" /></span>Odyssa Business Centre, Office # 412, 4th Floor, Nh-16, Sector A, Rasulgarh, Bhubaneswar, Odisha 751010
              </p>
              <a href="mailto:swayansidha.m@natioinfotech.com" className="flex gap-2 items-center">
                <FaEnvelope className="text-primaryColor" /> swayansidha.m@ <br /> natioinfotech.com
              </a>
            </div>
          </div>

        </div>

        <div className="border-t pt-6 flex flex-col sm:flex-row justify-between  text-secondaryTextColor">
          <p>All rights reserved © {new Date().getFullYear()} - <span className="font-semibold">NATIO</span></p>
          <p className="mt-2 sm:mt-0">
            Design & Developed by{" "}
            <a href="https://www.webbocket.com/" target="_blank" className="font-semibold hover:text-primaryColor transition cursor-pointer">
              Web_Bocket
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default MainFooter;
